module.exports = __webpack_public_path__ + "static/media/collapse.8807e950.svg";